import { apiClient } from '@/api/client'
import type {
  NotificationLogListResponse,
  NotificationLogRead,
  NotificationSummaryResponse,
} from '@/api/types/notification'

export const getNotifications = async (
  params?: {
    domain?: string[]
    exclude_domain?: string[]
    has_errors?: boolean
    limit?: number
    offset?: number
  },
  signal?: AbortSignal,
): Promise<NotificationLogListResponse> => {
  // FastAPI の list[str] クエリは `?domain=a&domain=b` 形式で受け取るため、
  // axios のデフォルト配列シリアライズ (`domain[]=a`) を回避して URLSearchParams で組み立てる。
  const search = new URLSearchParams()
  for (const d of params?.domain ?? []) search.append('domain', d)
  for (const d of params?.exclude_domain ?? []) search.append('exclude_domain', d)
  if (params?.has_errors) search.set('has_errors', 'true')
  if (params?.limit !== undefined) search.set('limit', String(params.limit))
  if (params?.offset !== undefined) search.set('offset', String(params.offset))

  const query = search.toString()
  const url = query ? `/notifications?${query}` : '/notifications'
  const { data } = await apiClient.get<NotificationLogListResponse>(url, { signal })
  return data
}

export const getRunningNotifications = async (): Promise<NotificationLogRead[]> => {
  const { data } = await apiClient.get<NotificationLogRead[]>('/notifications/running')
  return data
}

export const getNotificationSummary = async (): Promise<NotificationSummaryResponse> => {
  const { data } = await apiClient.get<NotificationSummaryResponse>('/notifications/summary')
  return data
}
